<div class="froala-container">
  <div
    #editor
    [froalaEditor]="froalaOptions"
    [(froalaModel)]="editorContent"></div>
  <div *ngIf="isSaving" class="spinner-border color-secondary" role="status">
    <span class="visually-hidden">Saving...</span>
  </div>
</div>
